import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Footer from '../footer/Footer';
import heroImage from '../../../assets/img/hero/about-us-1.jpg';
import heroImage1 from '../../../assets/img/orgin.jpg';
import heroImage2 from '../../../assets/img/location.jpg';
import Image4 from '../../../assets/img/4.png';
import Image5 from '../../../assets/img/5.png';
import Image6 from '../../../assets/img/6.png';
import Image7 from '../../../assets/img/7.png';

import './other/aboutus/AboutUs.css';

const HERO_BY_TAB = {
  // 회사소개 탭별 히어로
  about: {
    title: '주식회사 가까운물류',
    description: '파트너와 함께 성장하는\n신뢰할 수 있는 물류 기업',
    image: heroImage,
  },
  values: {
    title: '조직도',
    description: '가까운물류의 조직 구성을\n확인하세요.',
    image: heroImage1,
  },
  location: {
    title: '위치/오시는길',
    description: '주식회사 가까운물류의\n위치 안내입니다.',
    image: heroImage2,
  },
  // 사업분야 탭별 히어로
  coupang: {
    title: '쿠팡사업부',
    description: '쿠팡 물류 시스템과의 연동을 통한\n효율적인 배송 서비스를 제공합니다.',
    image: Image7,
  },
  transport: {
    title: '운송사업부',
    description: '안전하고 신속한 화물 운송 서비스를 제공합니다.',
    image: Image5,
  },
  finance: {
    title: '총무부',
    description: '회사의 전반적인 행정 및\n재무 업무를 담당합니다.',
    image: heroImage,
  },
  shoppingmall: {
    title: '쇼핑몰사업부',
    description: '온라인 쇼핑몰 운영 및 관리 서비스를 제공합니다.',
    image: Image4,
  },
  process: {
    title: '프로세스',
    description: '체계적인 물류 운영 프로세스를 확인하세요.',
    image: Image6,
  },
};

const NAV_CONFIG = {
  company: {
    tabs: [
      { id: 'about', label: '회사소개', path: '/intro/about' },
      { id: 'values', label: '조직도', path: '/intro/values' },
      { id: 'location', label: '위치/오시는길', path: '/intro/location' },
    ],
  },
  business: {
    tabs: [
      { id: 'coupang', label: '쿠팡사업', path: '/business' },
      { id: 'transport', label: '운송사업', path: '/business/transport' },
      // { id: 'finance', label: '총무부', path: '/business/finance' },
      { id: 'shoppingmall', label: '쇼핑몰사업', path: '/business/shoppingmall' },
      { id: 'process', label: '프로세스', path: '/business/process' },
    ],
  },
};

const IntroductionTabs = ({ type = 'company', children }) => {
  const location = useLocation();
  const config = NAV_CONFIG[type] || NAV_CONFIG.company;
  const tabs = config.tabs || [];

  const getActiveTabFromPath = () => {
    const matchedTab = tabs.find((tab) => location.pathname === tab.path);
    return matchedTab ? matchedTab.id : tabs[0]?.id;
  };

  const [activeTab, setActiveTab] = useState(getActiveTabFromPath);

  useEffect(() => {
    const matchedTab = tabs.find((tab) => location.pathname === tab.path);
    const newActiveTab = matchedTab ? matchedTab.id : tabs[0]?.id;

    if (newActiveTab && newActiveTab !== activeTab) {
      setActiveTab(newActiveTab);
    }
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  const heroContent = HERO_BY_TAB[activeTab] || HERO_BY_TAB.about;

  return (
    <>
      {/* 히어로 배너 섹션 */}
      <div
        className={`intro-hero-section community-hero-left ${activeTab === 'location' ? 'intro-hero-location' : ''} ${activeTab === 'about' ? 'intro-hero-about' : ''}`}
        style={{ backgroundImage: `url(${heroContent.image})` }}
      >
        <div className="intro-hero-overlay"></div>
        <div className="intro-hero-content">
          <h1>{heroContent.title}</h1>
          {heroContent.description && (
            <p className="intro-hero-description">
              {heroContent.description.split('\n').map((line, i) => (
                <span key={i}>{line}{i === 0 && <br />}</span>
              ))}
            </p>
          )}
        </div>
      </div>

      {/* 가로 탭 + 메인 콘텐츠 레이아웃 */}
      <div className="community-horizontal-layout">
        {tabs.length > 0 && (
          <nav className="community-horizontal-tabs">
            {tabs.map((tab) => (
              <Link
                key={tab.id}
                to={tab.path}
                className={`community-horizontal-tab ${activeTab === tab.id ? 'active' : ''}`}
              >
                {tab.label}
              </Link>
            ))}
          </nav>
        )}

        <main className="community-horizontal-content">
          {React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) return null;

            const childTabId = child.props.tabId;
            if (childTabId !== activeTab) return null;

            const { tabId, children: childChildren, ...restProps } = child.props;

            return React.createElement(
              child.type,
              { ...restProps, key: activeTab },
              childChildren
            );
          })}
        </main>
      </div>

      <Footer />
    </>
  );
};

export default IntroductionTabs;
